import { render } from "./UserGroupUpdate.vue?vue&type=template&id=06306ea0&scoped=true"
import script from "./UserGroupUpdate.vue?vue&type=script&lang=js"
export * from "./UserGroupUpdate.vue?vue&type=script&lang=js"

import "./UserGroupUpdate.vue?vue&type=style&index=0&id=06306ea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06306ea0"]])

export default __exports__